import React, { useState } from 'react';
import { MessageSquare, Send, Shield, User } from 'lucide-react';

export const MultiplayerChat: React.FC = () => {
  const [messages, setMessages] = useState<{ id: string, sender: string, role: string, text: string, time: string }[]>([
    { id: '1', sender: 'System', role: 'system', text: 'Welcome to the War Room. Secure channel established.', time: '08:00' }
  ]);
  const [input, setInput] = useState('');

  const handleSend = () => {
    if (!input.trim()) return;
    const newMsg = {
      id: Math.random().toString(36).substr(2, 9),
      sender: 'Commander',
      role: 'blue',
      text: input,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };
    // Use functional form to avoid stale closure over messages array
    setMessages(prev => [...prev, newMsg]);
    setInput('');
  };

  return (
    <div className="bg-slate-900/95 backdrop-blur border border-slate-700 rounded-lg flex flex-col h-64 w-80 shadow-2xl">
      <div className="p-3 border-b border-slate-700 flex items-center gap-2 bg-slate-800/80 rounded-t-lg">
        <MessageSquare className="w-4 h-4 text-ops-blue" />
        <span className="text-sm font-bold text-slate-200 tracking-wide">SECURE COMMS</span>
        <div className="ml-auto flex items-center gap-1">
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
          <span className="text-[10px] text-slate-500 font-mono">ENCRYPTED</span>
        </div>
      </div>
      
      <div className="flex-1 overflow-y-auto p-3 space-y-3 custom-scrollbar">
        {messages.map(msg => (
          <div key={msg.id} className="text-sm group">
            <div className="flex items-baseline gap-2 mb-0.5">
              {msg.role === 'system' ? (
                <Shield className="w-3 h-3 text-yellow-500" />
              ) : (
                <User className="w-3 h-3 text-blue-400" />
              )}
              <span className={`font-bold text-xs font-mono ${
                msg.role === 'system' ? 'text-yellow-500' : 
                msg.role === 'blue' ? 'text-blue-400' : 'text-red-400'
              }`}>
                {msg.sender.toUpperCase()}
              </span>
              <span className="text-[10px] text-slate-600 group-hover:text-slate-500 transition-colors">{msg.time}</span>
            </div>
            <p className="text-slate-300 leading-snug pl-5">{msg.text}</p>
          </div>
        ))}
      </div>

      <div className="p-2 border-t border-slate-700 bg-slate-800/30 rounded-b-lg">
        <div className="flex gap-2">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSend()}
            placeholder="Transmit message..."
            className="flex-1 bg-slate-950 border border-slate-700 rounded px-2 py-1.5 text-sm text-slate-200 focus:outline-none focus:border-ops-blue focus:ring-1 focus:ring-ops-blue/50 transition-all placeholder:text-slate-600"
          />
          <button 
            onClick={handleSend}
            className="p-1.5 bg-ops-blue hover:bg-blue-600 text-white rounded transition-colors shadow-lg shadow-blue-900/20"
          >
            <Send className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
